export class ScrollTop {
	private button: HTMLButtonElement;

	constructor(button: HTMLButtonElement) {
		if (!button) return;
		this.button = button;

		this.init();
	}

	private init = (): void => {
		this.button.addEventListener('click', this.handleClick);
	};

	public destroy = (): void => {
		this.button.removeEventListener('click', this.handleClick);
	};

	private handleClick = (): void => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};
}
